/* eslint-disable prettier/prettier */
//Services
import QuestionarioService from "@/views/RecursosPropriosQuestionarios/shared/services/QuestionarioService";

export default {
  mixins: [QuestionarioService],
  data() {
    return {
      idRnpPrestador: -1,
      loadingPrestador: false,
      podeEnviarArquivo: false,
      codigoUnimed: "",
      iniciado: false,
      tipoQuestionario: {
        idTipoQuestionario: "",
        tipoQuestionario: ""
      },
      id: "",
      payloadServicos: [],
      payloadEspecialidades: [],
      payloadAbrangencias: [],
      listaArquivos: [],
      objetosParaUpload: [],
      render: false,
      status: ""
    };
  },
  beforeMount() {
    this.iniciarQuestionario();
  },
  methods: {
    iniciarQuestionario() {
      this.$store.dispatch("recuperarIdPrestador");
      const id = this.$store.getters.getPrestadorId;
      const url = this.CriarUrl({
        resource: `questionario?rnpPrestadorId=${id}`
      });
      this.$store.dispatch("puxarDadosSalvosServidor", url).finally(() => {
        this.preencheDadosTipoQuestionario();
        this.preencheDadosIdQuestionario();
        this.render = true;
      });
    },
    captarPayloadServicos(payload) {
      this.payloadServicos = [...payload.servicos];
      this.payloadEspecialidades = [...payload.especialidades];
      this.payloadAbrangencias = [...payload.abrangencias];
    },
    FormataDadosParaEnviar(rascunho) {
      const dadosPost = {
        horarioFuncionamento: this.$refs.dadosCadastrais.preparaDadosHorarioFuncionamento(),
        tipoQuestionario: this.preparaDadosTipoQuestionario(),
        remuneracoes: this.$refs.objetoInfraestrutura.preparaDadosRemuneracoes(
          false
        ),
        prontuarios: this.$refs.objetoInfraestrutura.preparaDadosProntuarios(
          false
        ),
        complexidades: this.$refs.complexidades.preparaDadosComplexidade(),
        servicos: [...this.payloadServicos],
        especialidades: [...this.payloadEspecialidades],
        transplantes: [],
        abrangencias: [...this.payloadAbrangencias],
        servicosTerceirizados: this.$refs.objetoInfraestrutura.preparaDadosServicosTerceirizados(
          false
        ),
        servicosPublicos: [],
        atendimentoIntercambio: this.$refs.atendimentoIntercambio.preparaDados(),
        diretorTecnico: this.$refs.diretorTecnico.preparaDadosDiretorTecnico(),
        status: rascunho ? 'RASCUNHO' : 'FINALIZADO'
      };
      this.$store.commit("setFetched", false);
      console.log("post", dadosPost);
      return dadosPost;
    },
    FormataDadosParaAlterar(rascunho) {
      const dadosPut = {
        id: this.id,
        horarioFuncionamento: this.$refs.dadosCadastrais.preparaDadosHorarioFuncionamento(),
        tipoQuestionario: this.preparaDadosTipoQuestionario(),
        remuneracoes: this.$refs.objetoInfraestrutura.preparaDadosRemuneracoes(
          true
        ),
        prontuarios: this.$refs.objetoInfraestrutura.preparaDadosProntuarios(
          true
        ),
        complexidades: this.$refs.complexidades.preparaDadosComplexidade(),
        servicos: [...this.payloadServicos],
        especialidades: [...this.payloadEspecialidades],
        transplantes: [],
        abrangencias: [...this.payloadAbrangencias],
        servicosTerceirizados: this.$refs.objetoInfraestrutura.preparaDadosServicosTerceirizados(
          true
        ),
        servicosPublicos: [],
        atendimentoIntercambio: this.$refs.atendimentoIntercambio.preparaDados(),
        diretorTecnico: this.$refs.diretorTecnico.preparaDadosDiretorTecnico(),
        status: rascunho ? 'RASCUNHO' : 'FINALIZADO'
      };
      this.$store.commit("setFetched", false);
      console.log("put", dadosPut);
      return dadosPut;
    },
    async salvar(rascunho = false) {
      this.mostrarModalSalvar = false;
      this.salvando = true;
      const { id } = this.$route.params;
      this.idRnpPrestador = id;
      await this.salvarQuestionario(id, rascunho)
        .then(() => {
          return this.uploadArquivos();
        })
        .then(() => {
          this.salvando = false;
          console.log("Questionario salvo com sucesso ");
        })
        .catch(error => {
          console.log(error);
        });
    },
    async salvarQuestionario(idRnpPrestador, rascunho) {
      if (this.id) {
        await this.putQuestionario(this.FormataDadosParaAlterar(rascunho));
        await this.postQuestionarioLog(this.id, this.FormataDadosParaAlterar(rascunho));
        if (!rascunho) {
          this.$router.push("/recursos-proprios");
        } else {
          this.mostrarModalRascunho = false;
          this.status = 'RASCUNHO';
          this.iniciarQuestionario();
        }
      } else {
        const { data } = await this.postQuestionario(
          idRnpPrestador,
          this.FormataDadosParaEnviar(rascunho)
        );
        await this.postQuestionarioLog(data.id, this.FormataDadosParaEnviar(rascunho)); 
        if (!rascunho) {
          this.$router.push("/recursos-proprios");
        } else {
          this.mostrarModalRascunho = false;
          this.status = 'RASCUNHO';
          this.iniciarQuestionario();
        }
      }
    },
    voltar() {
      this.$router.push("/recursos-proprios");
    },
    fecharQuestionario(valor) {
      if (!valor) {
        this.$emit("input", false);
      }
    },
    async preencheDadosTipoQuestionario() {
      const url = this.CriarUrl({ resource: "tipo_questionario" });

      const query = {
        tipo: "Form_Pronto_Socorro",
        url
      };
      const tipoForm = await this.$store.dispatch(
        "puxarTiposQuestionarios",
        query
      );
      
      this.tipoQuestionario = tipoForm;
    },
    preparaDadosTipoQuestionario() {
      return this.tipoQuestionario;
    },
    preencheDadosIdQuestionario() {
      const data = this.$store.getters.getPayloadServidor();

      if (data) {
        if (data.id) {
          this.id = data.id;
          this.status = data.status;
        }
      }
    },
    preparaDadosIdQuestionario() {
      return this.id;
    },
    uploadArquivoHandler(objetoUpload) {
      const { formData } = objetoUpload;

      const existe = this.objetosParaUpload.find(
        obj => obj.formData === formData
      );

      if (existe) return;

      this.objetosParaUpload.push(objetoUpload);
    },
    uploadArquivos() {
      this.objetosParaUpload.forEach(obj => {
        const { formData, campo } = obj;

        return this.putUploadArquivo(formData, campo, porcentagem => {
          console.log(porcentagem);
        });
      });
    }
  },
  computed: {
    enviarDesativado() {
      return this.objetoInformacoes.length <= 0;
    }
  }
};
